import styles from './overlay.module.scss';

interface IOverlayProps extends IChildren {
  className?: string;
}
function Overlay({ children, className }: IOverlayProps) {
  const css = [styles.overlay];
  className && css.push(className);

  return <div className={css.join(' ')}>{children}</div>;
}

export default Overlay;
